import { List, ListItem, ListItemButton, Typography } from '@mui/material';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useLocation, useNavigate } from 'react-router';
import SportsList from './SportsList';
import { StyleObj } from '../../../../@types';
import { FEATURE_FLAG } from '../../../../constants/featureFlags';
import PromoIcon from '../../../icons/PromoIcon';
import useLocalization from '../../../../hooks/useLocalization';
import useProductAvailability from '../../../../hooks/useProductAvailability';
import { mergeSx } from '../../../../utils/styles';

const styles: StyleObj = {
  navList: {
    py: 0,
  },
  navListItem: {
    p: 0,
    borderBottom: 1,
    borderColor: 'neutral.700',
  },
  navListItemSelected: {
    position: 'relative',
    backgroundColor: 'neutral.700',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: 2,
      backgroundColor: 'info.main',
    },
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  navListItemButton: {
    px: 1,
    py: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  navLabel: {
    color: 'neutral.200',
  },
  navIcon: {
    color: 'neutral.300',
    typography: 'h3',
  },
  navIconActive: {
    color: 'info.main',
  },
};

type BettingDrawerContentProps = {
  onNavigate?: () => void;
};

const BettingDrawerContent = ({ onNavigate }: BettingDrawerContentProps) => {
  const { hasSportsbookAccess } = useProductAvailability();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLocalization();
  const promotionsEnabled = useFeatureIsOn(FEATURE_FLAG.PROMOTIONS_ENABLED);

  if (!hasSportsbookAccess) return null;

  const isPromotionsSelected = location.pathname.startsWith('/promotions');
  const handlePromotionsClick = () => {
    navigate('/promotions');
    onNavigate?.();
  };

  return (
    <>
      {promotionsEnabled && (
        <List sx={styles.navList}>
          <ListItem sx={mergeSx(styles.navListItem, isPromotionsSelected && styles.navListItemSelected)}>
            <ListItemButton sx={styles.navListItemButton} onClick={handlePromotionsClick} disableGutters>
              <Typography variant='body2' sx={styles.navLabel}>
                {t('promotions', 'Promotions')}
              </Typography>
              <PromoIcon sx={mergeSx(styles.navIcon, isPromotionsSelected && styles.navIconActive)} />
            </ListItemButton>
          </ListItem>
        </List>
      )}

      <SportsList basePath='/sports' />
    </>
  );
};

export default BettingDrawerContent;
